import React from "react";
import "./App.css";
import Pathfinder from "./pathfinder/PathFinder";

function App() {
  return <Pathfinder></Pathfinder>;
}

export default App;
